var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: {
        placement: "bottom",
        width: 400,
        trigger: "hover",
        disabled: !_vm.isDown,
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "hide-tags-container as-full-wdith as-flex main-start cross-start",
        },
        [
          _vm._l(
            _vm.movieTags ? _vm.movieTags.slice(_vm.showTagNum) : [],
            function (item, index) {
              return [
                _c(
                  "span",
                  {
                    key: "tag_" + index,
                    ref: "tags",
                    refInFor: true,
                    class: ["tag-item", "f-1", "as-nowrap"],
                  },
                  [_vm._v(_vm._s(item))]
                ),
              ]
            }
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "container",
          staticClass: "container as-flex main-start corss-center",
          attrs: { slot: "reference" },
          slot: "reference",
        },
        [
          _c(
            "div",
            {
              ref: "slotContent",
              staticClass: "content as-flex main-start cross-end",
            },
            [
              _vm._l(_vm.movieTags, function (item, index) {
                return [
                  _c(
                    "span",
                    {
                      key: "tag_" + index,
                      ref: "tags",
                      refInFor: true,
                      class: [
                        "tag-item",
                        "f-1",
                        "as-nowrap",
                        index < _vm.showTagNum ? "" : "is-hidden",
                      ],
                    },
                    [_vm._v(_vm._s(item))]
                  ),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.isDown
            ? _c(
                "div",
                { staticClass: "go-item go-next as-flex cross-center" },
                [_c("i", { staticClass: "icon el-icon-arrow-down" })]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }